
import { CreateLabelText, GetTextStyle } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/AbstractScrollableContentView";
import { BasePaytableComponent } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/components/BasePaytableComponent";
import { SimpleTextPaytableComponentComponentPayload } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/components/SimpleTextPaytableComponent";
import { PaytableContentFactoryService } from "@westpierstudio/core-module-oryx/services";
import { GameServices } from "game/GameServices";
import { Container, DisplayObject } from "pixi.js";
import { DynamicPayoutComponent } from "./DynamicPayoutComponent";
import { TargetsComponent, TargetsComponentPayload } from "./TargetsComponent";
import { convertSpines } from "utils/Spine2Sprite";
import { BonusContentView } from "./BonusContentView";
import { CurrentPayListEntryContent, SymbolsPayout } from "@westpierstudio/core-module-oryx/components/ui/slot-game-ui/menu/paytable/PaytableContent";

export class PrinceOfThievesPaytableContentFactoryService extends PaytableContentFactoryService {

    public override createComponent(componentName: string, payload: unknown, services: GameServices, createLabelText: CreateLabelText, getTextStyle: GetTextStyle): BasePaytableComponent | Container<DisplayObject> | undefined {
        switch (componentName) {
            case `dynamic`:
                return new DynamicPayoutComponent(services, <SimpleTextPaytableComponentComponentPayload>payload, createLabelText);
            case `targets`:
                return new TargetsComponent(services, <TargetsComponentPayload>payload, createLabelText);
            case `bonus`:
                return new BonusContentView(services, <CurrentPayListEntryContent[]>payload, createLabelText);
            default:
                return super.createComponent(componentName, payload, services, createLabelText, getTextStyle);
        }
    }

    loadPaytableAssets(services: GameServices) {
        convertSpines(services, services.resources.getSpec(`paytable-spines`));
    }
}

